@if (config.mode !== 'list') {
  <div [ngClass]="{'basecard': !dialogRef}"
    [attr.data-form-ready]="formReady ? 'true' : null"
    [style.width.px]="dialogWidth" [style.height.px]="dialogHeight" [style.overflow-y]="dialogRef ? 'auto' : null">
    <app-form-top-actions [config]="config" [isPrint]="isPrint" (completeEvent)="reloadContent($event)"></app-form-top-actions>
    @if (dialogRef?.componentInstance?.dialogOptions?.hideTabs || isPrint) {
      <ng-container *ngTemplateOutlet="formContent"></ng-container>
    }
    @if (!dialogRef?.componentInstance?.dialogOptions?.hideTabs && !isPrint) {
      <mat-tab-group
        [(selectedIndex)]="selectedTopTab" (selectedTabChange)="topTabChanges($event)"
        mat-align-tabs="start" mat-stretch-tabs="false">
        <!-- [style.max-height.px]="formHeight" style="overflow:auto" -->
        <mat-tab>
          <ng-template mat-tab-label>
            <span style="pointer-events: all; text-align: center; align-items: center;"
              matTooltip="Item Details" data-tab-field="home">
              <mat-icon style="height: 28px; width: 28px; font-size: 28px" color="primary">home</mat-icon>
            </span>
          </ng-template>
          <ng-template matTabContent>
            <ng-container *ngTemplateOutlet="formContent"></ng-container>
          </ng-template>
        </mat-tab>
        @for (field of config.tabFields; track field) {
          <mat-tab [disabled]="field.disable">
            <ng-template mat-tab-label>
              <span style="pointer-events: all;" [matTooltip]="field.getTabLabel()" [attr.data-tab-field]="field.name">
                <!-- div style="display: flex" -->
                <!--div style="flex:10">{{field.getTabLabel(field.control?.value)}}</div field.getTabLabel(field.control?.value)-->
                @if (field.tabIcon) {
                  <mat-icon style="height: 24px; width: 24px; font-size: 24px" color="primary">{{field.tabIcon}}</mat-icon>
                }
                @if (!field.tabIcon) {
                  <div style="flex:3">{{field.getTabLabel()}}</div>
                }
                <!-- div style="margin-top: 1px; margin-bottom: 1px" class="our-tab-chip" *ngIf="!isPhone && field.getTabChip(field.control?.value)" -->
                @if (field.getTabChip(field.control?.value)) {
                  <button mat-mini-fab style="width: 18px; height: 18px; margin-bottom: 3px">{{field.getTabChip(field.control?.value)}}</button>
                }
                <!-- /div -->
                <!-- /div -->
              </span>
            </ng-template>
            <ng-template matTabContent>
              <div formHolder [style.max-height.px]="(isPhone || isPrint || !config.fixedFormHeight) ? null : formHeight"
              style="padding: 1em 10px 10px; padding-bottom:1em; overflow:auto">
                <app-ctl-holder [control]="field.control"></app-ctl-holder>
              </div>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    }
    <mat-card-content>
      <!-- appFormFieldHolder -->
      <!-- mat-error *ngIf="!initComplete">You have no controls on form, make sure you have declared page.pageFormArray and
      called initFormObject on page</mat-error -->
      <!-- mat-divider style="margin-top: 10px; margin-bottom:10px"></mat-divider -->
    </mat-card-content>
  </div>
}
<ng-template #formContent>
  <div class="formHolder" formHolder [style.max-height.px]="(isPhone || isPrint || !config.fixedFormHeight) ? null : formHeight"
    style="padding: 1em 10px 0px; overflow:hidden" [attr.data-is-print]="isPrint">
    @if (!initComplete || loadingData) {
        <div style="position: fixed; z-index: 99; margin-left: 30vw; margin-top: 10vh">
            <mat-spinner [diameter]="100"></mat-spinner>
        </div>
    }
    @if (initComplete) {
        <ng-content></ng-content>
    }
    <app-field-set [fieldSet]="config.fieldSet" [isPhone]="isPhone" [isPrint]="isPrint"
      [initComplete]="initComplete">
    </app-field-set>
    @if (isPrint && initComplete) {
      @for (tabField of config.tabFields; track tabField) {
        <div>
          <h2 class="mat-h2" style="margin-top: 1em">{{tabField.label}}</h2>
          <!-- div formHolder [style.max-height.px]="(isPhone || isPrint || !config.fixedFormHeight) ? null : formHeight"
          style="padding-top: 1em; padding-bottom:1em; overflow:auto" -->
          <app-ctl-holder [control]="tabField.control"></app-ctl-holder>
          <!-- /div -->
        </div>
      }
    }
    @if (!isPhone && formGroup.pristine) {
      <app-field-set [fieldSet]="config.fieldSet"
        [isPhone]="isPhone" [initComplete]="initComplete" [showAfter]="true">
      </app-field-set>
    }
  </div>
  <ng-container *ngTemplateOutlet="stdActions"></ng-container>
</ng-template>
<ng-template #stdActions>
  @if (!isPrint && !config.hideFormActions) {
    <div style="margin-bottom:5px; margin-top: 5px">
      @if (!dialogRef) {
        <app-form-actions [pageForm]="formGroup" (cancelChgs)="cancelChanges()" (save)="saveChanges()"
          (saveAndNew)="saveChangesAndNew()" (delete)="deleteObject()" [hideSaveAndNew]="config.mode === 'edit'"
          [myMode]="config.mode" [readonly]="config.readonly" [allowDelete]="config.allowDelete" [loading]="loadingData">
        </app-form-actions>
      }
      @if (dialogRef) {
        <app-form-actions [pageForm]="formGroup" (save)="saveChanges()" (cancelChgs)="cancelChanges()"
          [myMode]="config.mode" [readonly]="config.readonly" [loading]="loadingData">
        </app-form-actions>
      }
    </div>
  }
</ng-template>
